export const minimizeText = (text, maxLength = 30) => {
  if (text?.length <= maxLength) {
    return text ?? "Not Available";
  } else {
    return text ? `${text?.slice(0, maxLength)}...` : "Not Available";
  }
};
